import { queryOptions } from '@tanstack/react-query';

import rtwClient from '../apiService';

import SitesService from './sitesService';

// **** Queries **** //
export const getSiteQueryOptions = {
  regions: () =>
    queryOptions({
      queryKey: ['regions'] as const,
      queryFn: () => SitesService.getRegions(rtwClient),
      // Regions rarely change and are shared across admin pages, so cache them for 5 mins.
      staleTime: 300000,
    }),
  allowedSites: () =>
    queryOptions({
      queryKey: ['sites', 'allowedSites'] as const,
      queryFn: () => SitesService.getAllowedSites(rtwClient),
    }),
  emailSetting: (siteId: number) =>
    queryOptions({
      queryKey: ['sites', siteId, 'emailSetting'] as const,
      queryFn: () => SitesService.getEmailsForSite(siteId, rtwClient),
    }),
};

// **** Mutations **** //
